import { render, staticRenderFns } from "./modifyPublish.vue?vue&type=template&id=167870cf&scoped=true&"
import script from "./modifyPublish.vue?vue&type=script&lang=js&"
export * from "./modifyPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167870cf",
  null
  
)

export default component.exports